var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-nav-bar',{attrs:{"title":_vm.$t('customerManagement.title')}}),_c('md-field',{staticClass:"body-wrapper"},_vm._l((_vm.routerList),function(router){return _c('md-field-item',{key:router.path,attrs:{"title":router.title,"arrow":""},on:{"click":function($event){return _vm.goDetail(router.path)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }